module.exports = __webpack_public_path__ + "img/swipe.1e0dcb25.png";